import { createAction } from 'redux-actions';

import * as c from '../../constants/constants';

export const setSkillScatterChartCompetencyValue = createAction(
  c.SKILL_SCATTER_CHART_SET_COMPETENCY_VALUE,
  payload => payload
);
